export const ChatInput = 'atlantis-chat-input';
export const ChatMessage = 'atlantis-chat-message';
export const ChatPanel = 'atlantis-chat-panel';
export const MessagingLayout = 'atlantis-messaging-layout';
export const MessagingGroupChat = 'atlantis-messaging-group-chat';
export const MessagingGroupChats = 'atlantis-messaging-group-chats';
